'use client';
import {useEffect} from 'react';
export default function ClientSetup() {
  useEffect(() => {
    (async () => {
      if (!('PluralRules' in Intl)) await import('@formatjs/intl-pluralrules/polyfill');
      if (!('RelativeTimeFormat' in Intl)) {
        await import('@formatjs/intl-relativetimeformat/polyfill');
        await import('@formatjs/intl-relativetimeformat/locale-data/en');
        await import('@formatjs/intl-relativetimeformat/locale-data/ga');
      }
      if (!('ListFormat' in Intl)) {
        await import('@formatjs/intl-listformat/polyfill');
        await import('@formatjs/intl-listformat/locale-data/en');
        await import('@formatjs/intl-listformat/locale-data/ga');
      }
      if (!('Segmenter' in Intl)) {
        await import('@formatjs/intl-segmenter/polyfill-force');
      }
    })();
    const send = (payload: any) =>
      fetch('/api/client-error', {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify({...payload, ua: navigator.userAgent})
      }).catch(() => {});
    const onError = (e: ErrorEvent) =>
      send({type: 'error', message: e?.message, stack: e?.error?.stack});
    const onRejection = (e: PromiseRejectionEvent) =>
      send({type: 'unhandledrejection', message: String(e?.reason?.message ?? e?.reason), stack: e?.reason?.stack});
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);
  return null;
}
